@if (initialLoading()) {
<div class="flex items-center justify-center py-12">
  <div
    data-testid="provider-form-wrapper-loading"
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
  ></div>
</div>
} @else {
<app-add-form
  data-testid="provider-form-wrapper-add-form"
  #addForm
  [title]="config.title"
  [formFields]="formFields()"
  [initialData]="formData()"
  (formAction)="onFormAction($event)"
  [headerActions]="config.headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [loading]="loading()"
></app-add-form>
}

<p-toast data-testid="provider-form-wrapper-toast"></p-toast>
